import Domain from "./domain";
export default {
  methods: {
    getPolicies: async function() {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "policy/details",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    gePolicieById: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "policy/details/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postPolicie: async function(obj) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "policy",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    putPolicie: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "policy",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deletePolicie: async function(id) {
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "policy/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postContractorImage: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "customer/company/contractor/avatar",
          obj,
          Domain.APP_HEADER_FORM_DATA
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postAssigning: async function(obj) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "policy/company",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
